<app-brand-header #header [brandProfile]="brandProfile" [pageContent]="pageContent"  [isLogoutVisible]="isLogoutVisible"> </app-brand-header>

<main class="dsb-cv-container">

    @if(isOtpTitleShown) {
        <div class="dsb-cv-title"><h3>{{otpTitle}}</h3></div>
    }

    @if(isOtpSubtitleShown) {
        <div class="dsb-cv-prompt"><label>{{otpSubtitle}}</label></div>
    }

  <!-- <div class="dsb-cv-form"> -->

    @if(isStepOneShown && !hasOnlyOneDestinationOption) {

      <form [formGroup]="ovForm" (ngSubmit)="onOtpGenerationSubmit()">

        <div class="dsb-cv-body-left">
<!-- 
          <div class="form-check">
            <input type="radio" class="form-check-input" name="otpSendMethod" formControlName="otpSendMethod" id="option1" value="textMessage">
            <label class="form-check-label" for="option1">{{optionSendText}}</label>
            <img src="../../assets/images/text-icon.png" style="margin-left: 1em;"/>
          </div>
          <div class="form-check">
            <input type="radio" class="form-check-input" name="otpSendMethod" formControlName="otpSendMethod" id="option2" value="phoneCall">
            <label class="form-check-label" for="option2">{{optionPhoneCall}}</label>
            <img src="../../assets/images/voice-icon.png" style="margin-left: 1em;" />
          </div>
          <div class="form-check">
            <input type="radio" class="form-check-input" name="otpSendMethod" formControlName="otpSendMethod" id="option3" value="email">
            <label class="form-check-label" for="option3">{{optionSendEmail}}</label>
            <img src="../../assets/images/email-icon.png" style="margin-left: 1em;" />
          </div>
 -->
<!--           
          @for (item of options; track item) {
            <div class="form-check">
              <input type="radio" class="form-check-input" name="otpSendMethod" formControlName="otpSendMethod" [id]="item[0]" [value]="item[0]">
              <label class="form-check-label" [for]="item[0]">{{item[1]}}</label>
            </div>
          } @empty {  
      
          }
 -->

<!--  
          <div *ngFor="let option of options">
            <div class="form-check">
              <input type="radio" class="form-check-input" name="otpSendMethod" formControlName="otpSendMethod" [id]="option[0]" [value]="option[0]" (click)="onOptionChange(option[0])">
              <label class="form-check-label" [for]="option[0]">{{option[1]}}</label>
            </div>
          </div>
-->

          <div *ngFor="let option of otpDestinationOptions"> 
            <div class="form-check">
              <input type="radio" class="form-check-input" name="otpDestinationId" formControlName="otpDestinationId" 
                  [id]="option.otpDestinationId" [value]="option.otpDestinationId" (click)="onOptionChange(option.otpDestinationId)">
              <label class="form-check-label" [for]="option.otpDestinationId">{{option.maskedAddressOrNumber}}</label>
              @if(option.otpDestinationType == 'EMAIL_ADDRESS') {
                <img src="../../assets/images/email-icon.png" style="margin-left: 1em;" />
              }
              @if(option.otpDestinationType == 'PHONE_NUMBER') {
                <img src="../../assets/images/text-icon.png" style="margin-left: 1em;" />
              }
            </div>
          </div>

        </div>

        <div class="dsb-cv-body-center">
          <div>
            <button type="submit" class="dsb-cv-btn" [disabled]="!ovForm.valid">Submit</button>
            <button type="button" class="dsb-cv-btn-cancel" (click)="onCancel()">Cancel</button>
          </div>
          <div>
          </div>
        </div>

      </form>

    }

    @if(isStepTwoShown) {
      <div class="dsb-cv-body-center">
        @if(isOtpPromptShown) {
          <h5 style="align-items: center;">{{otpPrompt}}</h5>
        }
        <ng-otp-input #ngOtpInput (onInputChange)="onOtpChange($event)" [config]="{ length: 6, allowNumbersOnly: true, showError: true }"></ng-otp-input>
        @if(isOtpWarningShown) {
          <label style="align-items: center;">{{otpWarning}}</label>
        }
      </div>
    }

  <!-- </div> -->

  @if(showErrorMessage) {
    <div class="alert alert-danger" role="alert">
        {{errorMessage}}
    </div>
  }

  @if(isOtpRequestShown) {
    <a [routerLink]="[]" (click)="onResendAuthCode()">{{otpRequest}}</a>
  }

  @if(isCancelLinkShown) {
    <a [routerLink]="[]" (click)="onCancel()">Cancel</a>
  }

</main>


<!-- 
    <form #form role="form" [formGroup]="ovForm">
  
      <section>
  
                <div class="form-group">
                    <label>Authorization Code</label>
                    <div class="input-group">
                        <input type="text" formControlName="otp"
                            pattern="^[0-9]{6}$"
                            class="form-control" id="otp" placeholder="" />
                    </div>
                    <div *ngIf="!ovForm.controls['otp'].valid && ovForm.controls['otp'].dirty" class="alert alert-danger">
                        Incorrect six-digit code
                    </div>
                </div>

      </section>
  
    </form>
-->


